import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import s from './styles.module.scss'

export const RoomEmpty = () => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <p className={clsx('bold-18', s.title)}>
        {t('tours_block.room_empty_title')}
      </p>
      <p className={clsx('medium-14', s.subtitle)}>
        {t('tours_block.room_empty_subtitle')}
      </p>
    </div>
  )
}
